package pl.finn.forms.ezw

import io.kvision.form.upload.UploadInput
import io.kvision.html.Button
import io.kvision.modal.Confirm
import io.kvision.redux.createReduxStore
import io.kvision.utils.getContent
import kotlinx.browser.window
import kotlinx.coroutines.CoroutineScope
import kotlinx.coroutines.Dispatchers
import kotlinx.coroutines.SupervisorJob
import pl.finn.forms.App
import pl.finn.forms.FormsService
import pl.finn.forms.PodgladWindow
import pl.finn.forms.launchWithProgress
import pl.finn.forms.Zalacznik

object Model : CoroutineScope by CoroutineScope(Dispatchers.Default + SupervisorJob()) {


  val formsService = FormsService()
  val ezwService = EzwService()

  val formularzStore =
    createReduxStore(
      ::formularzReducer,
      Formularz(FormularzWidok.PUSTY)
    )

  fun nowy(token: String, app: App) {
    launchWithProgress {
      val formData = ezwService.nowy(token)
      formularzStore.dispatch(FormularzAction.Nowy(formData))
      app.aktywujEzw()
      window.scrollTo(0.0, 0.0)
    }
  }

  fun sprawdz() {
    val state = formularzStore.getState()
    launchWithProgress {
      val res = ezwService.sprawdz(state.form!!, state.token!!)
      println(res)
    }
  }

  fun zapisz(form: EzwForm, validateResult: String?) {
//    if(validateResult == null){
      launchWithProgress {
        val state = formularzStore.getState()
        val url = ezwService.zapisz(form, validateResult, state.token!!)
        window.location.href = url
      }
//    } else {
//      sprawdz()
//    }
  }

  fun podglad(form: EzwForm, button: Button) {
    launchWithProgress {
      val state = formularzStore.getState()
      val xml = ezwService.podglad(form, state.token!!)
      PodgladWindow(state.token).pokazTresc(xml, button)
    }
  }

  fun edycja(token: String, app: App) {
    launchWithProgress {
      val formData = ezwService.edycja(token)
      formularzStore.dispatch(FormularzAction.Edycja(formData))
      app.aktywujEzw()
      window.scrollTo(0.0, 0.0)
    }
  }

  fun anuluj() {
    launchWithProgress {
      val state = formularzStore.getState()
      val url = formsService.anuluj(state.token!!)
      window.location.href = url
    }
  }

  fun dodajZalacznik(zalacznik: UploadInput, opisZalacznika: String?, form: EzwForm) {
    launchWithProgress {
      zalacznik.value?.firstOrNull()?.let {
        val dataContent = zalacznik.getNativeFile(it)?.getContent()
        val parts = dataContent?.split(",")
        val mime = parts?.get(0)?.drop(5)?.dropLast(7)
        val content = parts?.getOrNull(1)
        Model.formularzStore.dispatch(
          FormularzAction.DodajZalacznik(
            Zalacznik(
              it.name,
              opisZalacznika,
              mime,
              content
            ),
            form
          )
        )
      }
    }
  }

  fun usunZalacznik(nazwa: String, form: EzwForm) {
    Confirm.show(
      "Potwierdzenie",
      "Czy na pewno usunąć wybrany załącznik?",
      yesTitle = "Tak",
      noTitle = "Nie"
    ) {
      Model.formularzStore.dispatch(FormularzAction.UsunZalacznik(nazwa, form))
    }
  }

}